import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
	Col,
	Card,
	CardHeader,
	CardBody,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import ReactFileReader from 'react-file-reader';
import PLUSIMAGE from '../assets/plus.png';
import AppPage from '../views/AppPage';
import PhotoGallery from 'react-grid-gallery';
import Sanitize from '../Sanitize';
const GLOBAL = require('../Globals');

const styles = {
	sBox: {
	    position: 'absolute',
		top: '0px',
		right: '10px',
		width: '170px'
	},
	imgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',height : '120px'
	},
	plusImgStyle : {
		padding:'10px',border : '1px solid #d8d8d8',margin : '10px',backgroundColor : '#f1f1f1',cursor : 'pointer'
	},
	btnStyle : {
		position: 'absolute',
		top: '1px',
		right: '-17px',
		borderRadius: '24px',
		cursor : 'pointer'
	}
}

class Gallery extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			title :'',
			order :'',
			imgkey :'',
			files: [],
			files1 : [],
			dataView : [],
			imgData : [],
			images : [],
			modal : false,
			editmodal : false
		}
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.getFiles = this.getFiles.bind(this);
		this.onChange = this.onChange.bind(this);
		this.toggle = this.toggle.bind(this);
		this.edittoggle = this.edittoggle.bind(this);
		this.onUpdateSubmit = this.onUpdateSubmit.bind(this);
	}
	
	onRemove(key,e){
		if(window.confirm('Do you want to Remove?')){
			
			$("#showLoader").show();			
			GetData('slider/removegallerybytitle/'+key).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Gallery Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Gallery',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	onEditModal(key,e){
		
		var d = this.state.dataView;
		
		var dat = d.filter(function(obj){
			return(obj.img_key == key);
		});
		if(dat.length > 0){
			this.setState({title : dat[0]['title'],order : dat[0]['displayorder'],imgkey : dat[0]['img_key']});
		}
		let IMAGES = [];
		dat.map((item,i)=>{
			IMAGES.push({
				src : GLOBAL.BASE_URL+item.image,
				thumbnail : GLOBAL.BASE_URL+item.image,
				thumbnailWidth: 20,
				thumbnailHeight: 20,
				tags: [
					{value : <div>
						<button type="button" className="btn btn-danger btn-xss" onClick={this.handleClick.bind(this,item.id)}><i className="fa fa-remove"></i></button>
						</div> }
				],
				caption: GLOBAL.BASE_URL+item.image}) 
		});
		this.setState({images : IMAGES,editmodal : true});
	}
	
	onViewModal(key,e){
		var d = this.state.dataView;
		
		var dat = d.filter(function(obj){
			return(obj.img_key == key);
		});
		if(dat.length > 0){
			this.setState({title : dat[0]['title']});
		}
		let IMAGES = [];
		dat.map((item,i)=>{
			IMAGES.push({
				src : GLOBAL.BASE_URL+item.image,
				thumbnail : GLOBAL.BASE_URL+item.image,
				thumbnailWidth: 20,
				thumbnailHeight: 20,
				tags: [
					{value : <div>
						<button type="button" className="btn btn-danger btn-xss" onClick={this.handleClick.bind(this,item.id)}><i className="fa fa-remove"></i></button>
						</div> }
				],
				caption: GLOBAL.BASE_URL+item.image}) 
		});
		this.setState({images : IMAGES,modal : true});
	}
	
	toggle(e){
		this.setState({modal : !this.state.modal});
	}
	
	edittoggle(e){
		this.setState({editmodal : !this.state.editmodal});
	}
	
	onChange(e){
		this.setState({[e.target.name] : e.target.value});
	}

	getFiles(files){
	
		if(this.state.files.length > 0){
			for(var i=0;i<(files.base64).length;i++){
				this.state.files.push(files.base64[i]);
			}
			this.setState({files : this.state.files});
		}else{
			this.setState({ files: files.base64});
		}

		if(this.state.files1.length > 0){
			for(var i=0;i<files.length;i++){
				this.state.files1.push(files);
			}
			this.setState({files1 : this.state.files});
		}else{
			this.setState({ files1: files});
		}
	}
	
	handleRemove(index){

		this.state.files.splice(index,1);
		this.setState({files : this.state.files});
	}

	/** submit form **/
	onSubmit(e){
		$("#showLoader").show();
			var data = {title : this.state.title,order : this.state.order,files1 : this.state.files1};
			PostData('slider/savegallery',{sdata : data}).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Gallery Added Successfully!..',
						alertClass:'alert alert-success',
						files : [],
					});
					$("#order").val('');
					$("#title").val('');
					this.getdata();
				}
				else{
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
	}
	
	/** update submit form **/
	onUpdateSubmit(e){
		$("#showLoader").show();
			var data = {title : this.state.title,order : this.state.order,imgkey : this.state.imgkey,files1 : this.state.files1};
			PostData('slider/updategallery',{sdata : data}).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Gallery Updated Successfully!..',
						alertClass:'alert alert-success',
						files : [],
						files1 : [],
						title : '',
						order : '',
						imgkey : '',
						editmodal : false,
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
	}
	
	/** this function will be call when page loading **/
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('slider/getgallery').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson['status'] == 1){
				
				var result = Sanitize.groupByMultiple(responseJson['data'], function (item) {
                    return [item.img_key];
                });
				this.setState({
					dataView : responseJson['data'],
					imgData : result
				});
			}
		});
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) {
      $("#showLoader").show();			
			PostData('slider/removegallery',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Gallery Removed Successfullly',
						alertClass:'alert alert-success',
						editmodal : false
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Gallery',
						alertClass:'alert alert-danger'
					});
				}
			});
		}	
	}
	
  render() {
	
		let IMAGES = [];
		this.state.dataView.map((item,i)=>{
			IMAGES.push({
				src : GLOBAL.BASE_URL+item.image,
				thumbnail : GLOBAL.BASE_URL+item.image,
				thumbnailWidth: 20,
				thumbnailHeight: 20,
				tags: [
					{value : <div>
						<button type="button" className="btn btn-danger btn-xss" onClick={this.handleClick.bind(this,item.id)}><i className="fa fa-remove"></i></button>
						</div> }
				],
				caption: GLOBAL.BASE_URL+item.image}) 
		});

    return (
		<div>
			<AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
					<Col md={12}>
						<Card>
							<CardHeader>
								<strong>Gallery</strong>
								<button style={{float  :'right'}} className="btn btn-success btn-xs" onClick={this.onSubmit}>Save</button>
							</CardHeader>
							<CardBody>
							  <Row>
								<Col md={12}>
									<div style={{border: '1px solid #d8d8d8',minHeight : '110px'}}>
										<Row style={{marginTop : '10px'}}>
											<Col md={3} style={{paddingLeft : '25px'}}>Title</Col>
											<Col md={3}><input type="text" name="title" id="title" className="form-control" onChange={this.onChange} required /></Col>
											<Col md={3}>Order</Col>
											<Col md={3} style={{paddingRight : '25px'}}><input type="number" name="order" id="order" className="form-control" onChange={this.onChange} required /></Col>
										</Row>
										<Row>
											{this.state.files.map((item,i)=>{
												return(<Col md={2} style={{maxWidth : '11%'}}>
														<img src={item} width="120px" style={styles.imgStyle} />
														<button type="button" className="btn btn-danger btn-xss" style={styles.btnStyle} onClick={this.handleRemove.bind(this,i)}><i className="fa fa-remove"></i></button>
													</Col>);
											})}
											<Col md={2}>
												<ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} multipleFiles={true} base64={true} handleFiles={this.getFiles}>
													<img src={PLUSIMAGE} width="120px" style={styles.plusImgStyle} />
												</ReactFileReader>
											</Col>
										</Row>
									  </div>
								</Col>
							  </Row>
								<Row>
									<Col md={12}>
										<Table bordered responsive>
											<thead>
												<tr>
													<th>S.No</th>
													<th>Title</th>
													<th>Display Order</th>
													<th>Manage</th>
												</tr>
											</thead>
											<tbody>
												{this.state.imgData.map((item,i)=>{
													return <tr>
														<td>{i+1}</td>
														<td>{item[0].title}</td>
														<td>{item[0].displayorder}</td>
														<td>
															<button className="btn btn-info btn-sm" onClick={this.onEditModal.bind(this,item[0].img_key)}><i className="fa fa-edit"></i></button>&nbsp;
															<button className="btn btn-warning btn-sm" onClick={this.onViewModal.bind(this,item[0].img_key)}><i className="fa fa-eye"></i></button>&nbsp;
															<button className="btn btn-danger btn-sm" onClick={this.onRemove.bind(this,item[0].img_key)}><i className="fa fa-remove"></i></button>
														</td>
													</tr>
												})}
											</tbody>
										</Table>
									</Col>
									<Col md={12}>
										<PhotoGallery images={IMAGES}/>
									</Col>
								</Row>
							</CardBody>
						</Card>
						<Modal isOpen={this.state.modal} size="lg" toggle={this.toggle} className={this.props.className}>
							<ModalHeader toggle={this.toggle}>View Image - {this.state.title}</ModalHeader>
							<ModalBody>
								<Row>
									<Col md="12">
										<PhotoGallery images={this.state.images}/>
									</Col>
								</Row>
							</ModalBody>
						</Modal>
						<Modal isOpen={this.state.editmodal} size="lg" toggle={this.edittoggle} className={this.props.className}>
							<ModalHeader toggle={this.edittoggle}>Edit Image</ModalHeader>
							<ModalBody>
								<Row>
									<Col md={6}>
										<label>Title</label>
										<input type="text" name="title" className="form-control" value={this.state.title} onChange={this.onChange} />
									</Col>
									<Col md={6}>
										<label>Display Order</label>
										<input type="text" name="order" className="form-control" value={this.state.order} onChange={this.onChange} />
									</Col>
								</Row>
								<Row>
									<Col md="12">
										<PhotoGallery images={this.state.images}/>
									</Col>
								</Row>
								<Row>
									{this.state.files.map((item,i)=>{
										return(<Col md={2} style={{maxWidth : '15%'}}>
												<img src={item} width="120px" style={styles.imgStyle} />
												<button type="button" className="btn btn-danger btn-xss" style={styles.btnStyle} onClick={this.handleRemove.bind(this,i)}><i className="fa fa-remove"></i></button>
											</Col>);
									})}
									<Col md={2}>
										<ReactFileReader fileTypes={[".png",".jpg",".jpeg"]} multipleFiles={true} base64={true} handleFiles={this.getFiles}>
											<img src={PLUSIMAGE} width="120px" style={styles.plusImgStyle} />
										</ReactFileReader>
									</Col>
								</Row>
								<Row>
									<Col md={12}>
										<button style={{float  :'right'}} className="btn btn-success btn-xs" onClick={this.onUpdateSubmit}>Update</button>
									</Col>
								</Row>
							</ModalBody>
						</Modal>
					</Col>
				</Row>
			</div>	
		</div>
		)
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/Gallery/Gallery.js